var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "wrap wrap--join"
  }, [_c('main-header'), _c('main', {
    staticClass: "main",
    attrs: {
      "role": "main"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h2', {
    staticClass: "join-title"
  }, [_vm._v("회원가입")]), _c('div', {
    staticClass: "join-container"
  }, [_vm._m(0), _vm.hasAdditionalForm ? [_vm._m(1), _c('join-additional-form', _vm._b({
    staticClass: "mt-100"
  }, 'join-additional-form', {
    type: _vm.type,
    kind: _vm.kind
  }, false))] : [_vm._m(2), _vm._m(3)]], 2)])]), _c('main-footer')], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('nav', {
    staticClass: "join-step"
  }, [_c('ul', {
    staticClass: "join-step-lists"
  }, [_c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "badge"
  }, [_vm._v("1")]), _c('span', {
    staticClass: "text"
  }, [_vm._v("약관동의")])]), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "badge"
  }, [_vm._v("2")]), _c('span', {
    staticClass: "text"
  }, [_vm._v("정보입력")])]), _c('li', {
    staticClass: "list list--on"
  }, [_c('span', {
    staticClass: "badge"
  }, [_vm._v("3")]), _c('span', {
    staticClass: "text"
  }, [_vm._v("가입완료")])])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "join-complate"
  }, [_c('i', {
    staticClass: "join-complate__icon"
  }), _c('h3', {
    staticClass: "join-complate__title"
  }, [_vm._v("회원가입이 완료 되었습니다.")]), _c('p', {
    staticClass: "join-complate__text mt-40",
    staticStyle: {
      "line-height": "1.5"
    }
  }, [_vm._v(" 아래의 추가 입력 정보를 입력해 주세요."), _c('br'), _vm._v(" 지금 입력하지 않아도 다음에 입력하실 수 있습니다. ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "join-complate"
  }, [_c('i', {
    staticClass: "join-complate__icon"
  }), _c('h3', {
    staticClass: "join-complate__title"
  }, [_vm._v("회원가입이 완료 되었습니다.")]), _c('p', {
    staticClass: "join-complate__text"
  }, [_vm._v("가입해 주셔서 감사합니다.")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bottom-button"
  }, [_c('a', {
    staticClass: "button button--primary",
    attrs: {
      "href": "/"
    }
  }, [_c('span', [_vm._v("확인")])])]);
}]

export { render, staticRenderFns }